import { Fragment, useState} from 'react';
import { useSelector } from 'react-redux'
import { Navigate } from "react-router-dom";
import {Helmet} from "react-helmet"

import Select from 'react-select';
import PhoneInput from '../js/PhoneInput'
import local from './local/reg_localisation';

var HideBtn = false;
var Error = {
  email:false,
  login:false
}


export default function Login(){
    var labels = [];
    var err_labels = [];
    var msg = []; 
    
    const setup = useSelector(state => state.site.setup);
    const bases = useSelector(state => state.site.navbases.nums);
    const [phone, setPhone] = useState('');
    let LANG = setup.lang;

    msg['ru'] = 'Спасибо! Мы свяжемся с вами в ближайшее время.'
    msg['en'] = 'Thank you for your message! We will contact you!'
    msg['de'] = 'Vielen Dank für Ihre Nachricht! Wir melden uns bei Ihnen!'

    const AppArea = [
          { value: 'diy', label: local[LANG].diy },
          { value: 'pro', label: local[LANG].pro }
    ];

    const [AllIs, setAllIs] = useState({done:false, error:null, open:true, pshow:true});
    const [selAppAreaOption, setSelAppAreaOption] = useState(null);

    const [warn, setWarn] = useState({
                                      user: 'ok',
                                      mail: 'ok',
                                  soglasen: 'no'
                                    });

    const [password, setPass] = useState(null);
    const [login, setLogin] = useState(null);

    

const open = () => setAllIs({done:false, error:null, open:true}) 
const toggle = () => AllIs.pshow ? setAllIs({...AllIs, pshow:false}) : setAllIs({...AllIs, pshow:true})

const handlePassChange = (ev) => {
  const { value, name } = ev.target
  setPass( value )
}

function rus_to_latin(str) {

	const ru = new Map([
		['а', 'a'], ['б', 'b'], ['в', 'v'], ['г', 'g'], ['д', 'd'], ['е', 'e'],
		['є', 'e'], ['ё', 'e'], ['ж', 'j'], ['з', 'z'], ['и', 'i'], ['ї', 'yi'], ['й', 'i'],
		['к', 'k'], ['л', 'l'], ['м', 'm'], ['н', 'n'], ['о', 'o'], ['п', 'p'], ['р', 'r'],
		['с', 's'], ['т', 't'], ['у', 'u'], ['ф', 'f'], ['х', 'h'], ['ц', 'c'], ['ч', 'ch'],
		['ш', 'sh'], ['щ', 'shch'], ['ы', 'y'], ['э', 'e'], ['ю', 'u'], ['я', 'ya'],
    ['.','_'],[',','_'],['!','_'],['(','_'],[')','_'], ['ъ',''], ['+','_'], ['-','_'], 
    ['~','_'], ['`','_'], ['@','_'], [':','_'], [';','_'], ['/','_'], ['\\','_'], ['{','_'], ['}','_'], ['[','_'], [']','_'], 
    ['#','_'], ['$','_'], ['%','_'], ['^','_'], ['&','_'], ['*','_'], ['','_'], 
    ['\"','_'], ['№','_'], ['?','_'], ['<','_'], ['>','_'], ['\ ','_'],
	]);

	str = str.replace(/[ъь]+/g, '');

	return Array.from(str)
		.reduce((s, l) =>
			s + (
				  ru.get(l)
				  || ru.get(l.toLowerCase()) === undefined && l
				  || ru.get(l.toLowerCase()).toUpperCase()
			  )
			, '');
}

const LoginChange = (ev) => {
  const { value, name } = ev.target;
  setLogin(rus_to_latin(value));
  //console.log("LOG", value);
}


if(AllIs.error){
    return (
        <Fragment>
                <Fragment>
                <div className="login" onClick={toggle}>ASK QST: {AllIs.error.message}</div>
                </Fragment>
        </Fragment>
            )
} 

if(AllIs.done){
    return(  
    <Fragment>
            <Fragment>
            <div className="login">
                <p className="finalmsg">{msg}</p>
            </div>
            </Fragment>
            <Navigate to={'/'+setup.lang+'/login'} replace={true} />
    </Fragment>
    )
} 

return(
<Fragment>
      <Helmet>
        <title>{local[LANG].title}</title>
        <meta name="description" content={local[LANG].description} />
        <meta name="keywords" content={local[LANG].keywords} />
      </Helmet>
     {AllIs.open?
        <Fragment>

                <form name="registration" onSubmit={(ev)=>{SaveDATA(ev)}} className="login pt10">
                <h2>{local[LANG].regFormTitle}</h2>
                <input type="text" name="country" required placeholder={local[LANG].country}/>
                <input type="text" name="town" required placeholder={local[LANG].town}/>
                <input type="text" name="name" required placeholder={local[LANG].fio}/>
                <input type="email" name="email" required placeholder={local[LANG].mail} onBlur={(ev)=>{Check(ev)}} autoComplete='on'/>
                { warn.mail !=='ok' ? <p className='warn'>{warn.mail}</p> : null}
                <PhoneInput
                    value={phone} 
                    onChange={setPhone} 
                    placeholder="+7 (___) ___ __ __"
                />
                <br/>
                <input required type="text" value={login} name="user" placeholder={local[LANG].login} onBlur={(ev)=>{Check(ev)}} autoComplete='on' onChange={LoginChange}/>
                { warn.user !=='ok' ? <p className='warn'>{warn.user}</p> : null}
                <div className='password'>
                  { AllIs.pshow? <Fragment>
                              <input required type="password" placeholder={local[LANG].passw} onChange={handlePassChange}/>
                              <img src={setup.domen+'svg/pHide.svg'} className='ptoggler' onClick={toggle}/>
                          </Fragment> 
                  :
                          <Fragment>
                            <input required type="text" placeholder={local[LANG].passw} onChange={handlePassChange}/>
                            <img src={setup.domen+'svg/pShow.svg'} className='ptoggler' onClick={toggle}/>
                          </Fragment>
                  }
                </div>
                <br/>
                <Select
                  defaultValue={selAppAreaOption}
                  onChange={setSelAppAreaOption}
                  options={AppArea}
                  isSearchable={false}
                  styles={{
                      control: (baseStyles, state) => ({
                        ...baseStyles,
                        fontSize: '11pt',
                        padding:'0px 0px'
                      }),
                      option: (baseStyles, state) => ({
                          ...baseStyles,
                          fontSize: '11pt',
                        }),
                    }}
                  placeholder={local[LANG].apparea}
                />
                <br/>
                    {HideBtn? null : <button type="submit" className="btn submit w50">{local[LANG].sendbtn}</button>}
                </form>
        </Fragment>
     :null
     }
</Fragment>
 )   





 


function Check(ev){
  const { value, name } = ev.target;

  const form = new FormData()
          form.append('lang', setup.lang);
          form.append('value', value);
          form.append('tag', name);

    const MyInit = { 
                method: 'POST',
                body: form
                };
  fetch(setup.domen+setup.folder+'formcheck', MyInit)
    .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error(response.text()+'Something went wrong ...');
        }
    })
    .then(data => {
        let msg = data.resp;

        switch (name) {
        
          case 'user':
            if(msg !=='ok'){ Error.email = true; setWarn({...warn, user:msg}); }
                      else { Error.email = false; setWarn({...warn, user:'ok'}); }
            break;
        
            case 'email':
            if(msg !=='ok'){ Error.login = true; setWarn({...warn, mail:msg}); }
            else { Error.login = false; setWarn({...warn, mail:'ok'}); }
            break;
        }
                if(!Error.login && !Error.email) {HideBtn = false}
                else {HideBtn = true}
    })
    .catch(error => {
        //setAllIs({...AllIs, error:error});
    });
}







 function SaveDATA(ev){
  ev.preventDefault()
  var sndForm = document.forms.registration;
  //console.log('APP:', selAppAreaOption);
  //let AppArea = selAppAreaOption.map((k) => {return k.value}).join(",");

  const form = new FormData()
        form.append('lang', setup.lang);
        form.append('country', sndForm.elements.country.value);
        form.append('town', sndForm.elements.town.value);
        form.append('name', sndForm.elements.name.value);
        form.append('email', sndForm.elements.email.value);
        form.append('phone', '8'+phone);
        form.append('user', sndForm.elements.user.value);
        form.append('pass', password);
        form.append('apparea', selAppAreaOption.value);

    const MyInit = { 
                method: 'POST',
                body: form
                };
  fetch(setup.domen+setup.folder+'signup', MyInit)
    .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error(response.text()+'Something went wrong ...');
        }
    })
    .then(data => {
        msg = data.resp;
        setAllIs({...AllIs, done:true});
    })
    .catch(error => {
        setAllIs({...AllIs, error:error});
    });
  }


} //************ */